import DetallesEvaluacionDto from './DetallesEvaluacionDto'
import ReactivoDto from './ReactivoDto'

export default class RendimientoProfesionalismoDto {
  constructor(detalles, reactivos) {
    this.detalles = detalles
    this.reactivos = reactivos
  }

  toPrimitives() {
    return {
      ...this.detalles,
      frecuenciasMedicion: this.reactivos,
    }
  }

  static create(evaluacionDesempenioAcademico, catalogoReactivos = []) {
    return new RendimientoProfesionalismoDto(
      DetallesEvaluacionDto.create(evaluacionDesempenioAcademico),
      catalogoReactivos.map((reactivo) => ReactivoDto.create(reactivo))
    ).toPrimitives()
  }

  static update(evaluacionDesempenioAcademico) {
    // TODO: Improve this
    const detalles = {
      aspiranteAlPuesto: evaluacionDesempenioAcademico.detalle.puestoAspirado,
      calificacion: evaluacionDesempenioAcademico.calificacion,
      fechaAplicacion: evaluacionDesempenioAcademico.detalle.fechaAplicacion,
      fechaFin: evaluacionDesempenioAcademico.detalle.fechaFin,
      fechaInicial: evaluacionDesempenioAcademico.detalle.fechaInicial,
      fk_idCatEstatusEvaluacion: evaluacionDesempenioAcademico.detalle.status,
      fk_idCatMunicipio: evaluacionDesempenioAcademico.detalle.idMunicipio,
      fk_idPersonalEvaluador: evaluacionDesempenioAcademico.detalle.idEvaluador,
      fk_idResultado: evaluacionDesempenioAcademico.idResultado,
      institucionSeguridadAspira: evaluacionDesempenioAcademico.detalle.institucionSeguridadAspirada,
      observaciones: evaluacionDesempenioAcademico.detalle.observaciones,
      puntajeTotal: evaluacionDesempenioAcademico.puntajeTotal,
    }

    const reactivos = evaluacionDesempenioAcademico.reactivos.map((item) => ({
      estatus: item.estatus,
      fk_idCatFrecuencia: item.idFrecuencia,
      fk_idReactivoEvaluacion: item.idReactivo,
      id: item.id,
    }))

    return new RendimientoProfesionalismoDto(detalles, reactivos).toPrimitives()
  }
}
